import React from 'react';

export const ScoreGauge = ({ score, label }) => (
  <div className="mk-gauge">
    <div className="mk-gauge-dial">
      <svg viewBox="0 0 100 56" aria-hidden="true" focusable="false">
        <path d="M8 50 A42 42 0 0 1 92 50" className="mk-gauge-track" pathLength="100" />
        <path d="M8 50 A42 42 0 0 1 92 50" className="mk-gauge-fill" pathLength="100" strokeDasharray={`${score} 100`} />
      </svg>
      <div className="mk-gauge-val"><span className="mk-num">{score}</span><small>/100</small></div>
    </div>
    {label && <div className="mk-gauge-label">{label}</div>}
  </div>
);
